import "@splidejs/splide/css/core";
import Splide from "@splidejs/splide";

export default (ops, target) => ({
  instance: null,
  videoPlaying: null,

  init() {
    const el = target ? this.$el.querySelector(target) : this.$el;

    this.instance = new Splide(el, {
      ...ops,
    }).mount();

    // Splide uses the ARIA tab pattern (tablist/tab/tabpanel) whenever
    // pagination is enabled, but only sets slide roles once at mount. With
    // pagination toggled per-breakpoint this leaves orphaned tabpanels (or
    // tabs pointing at non-tabpanels), producing a malformed accessibility
    // tree. Normalize to the WAI-ARIA "grouped carousel" pattern instead:
    // slides are groups, pagination dots are plain labelled buttons.
    const normalizeRoles = () => {
      el.querySelectorAll(".splide__slide").forEach((slide) => {
        slide.setAttribute("role", "group");
      });

      el.querySelectorAll(".splide__pagination").forEach((list) => {
        // Buttons keep their "Go to page N" aria-labels from Splide.
        list.removeAttribute("role");
        list.removeAttribute("aria-orientation");

        list.querySelectorAll("li").forEach((li) => li.removeAttribute("role"));

        list.querySelectorAll("button").forEach((button) => {
          button.removeAttribute("role");
          button.removeAttribute("aria-selected");
        });
      });
    };

    normalizeRoles();
    // Re-apply whenever Splide re-renders pagination (breakpoint changes)
    // or re-sets aria-selected on the active dot (slide moves).
    this.instance.on(
      "updated resized moved pagination:mounted pagination:updated",
      normalizeRoles,
    );
  },

  playVideo(slideIndex) {
    this.videoPlaying = slideIndex;
    this.stopAutoplay();
  },

  isVideoPlaying(slideIndex) {
    return this.videoPlaying === slideIndex;
  },

  stopAutoplay() {
    if (!this.instance) {
      return;
    }

    const { Autoplay } = this.instance.Components;

    if (Autoplay) {
      Autoplay.pause();

      if (typeof Autoplay.destroy === "function") {
        Autoplay.destroy();
      }
    }

    this.instance.options.autoplay = false;
  },
});
